import React, { useEffect, useState } from 'react'

import { number, bool, func, object } from 'prop-types'

import CleanModal from '../../../components/shared/modals/CleanModal'
import FormBibliotecario from './FormBibliotecario'

const ModalBibliotecario = ({ onClose, open, data, id_bibliotecario }) => {
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setStatus(open)
  }, [open])

  useEffect(() => {
    onClose(status)
  }, [status])

  return (
    <CleanModal
      title="Editar Bibliotecário"
      sx={{ width: { xs: '100vw', md: '30vw' } }}
      status={status}
      onClose={() => onClose(false)}
    >
      <>
        <FormBibliotecario
          submitMethod="put"
          onSubmitEnd={() => {
            onClose(false)
          }}
          data={data}
          id={id_bibliotecario}
        />
      </>
    </CleanModal>
  )
}
ModalBibliotecario.propTypes = {
  open: bool,
  data: object,
  id_bibliotecario: number,
  onClose: func
}
export default ModalBibliotecario
